import App from '../shared/components/App';
import React from 'react';
import ThemeProvider from '@zg-rentals/multibrand-ui/lib/ThemeProvider';
import assign from 'lodash/assign';
import configureStore from '../shared/flux/configureStore';
import createHistory from 'history/createBrowserHistory';
import { ConnectedRouter, push, replace } from 'connected-react-router';
import { CookiesProvider } from 'react-cookie';
import { Provider } from 'react-redux';
import { RpErrorBoundary } from '@zg-rentals/rp-bootstrap-browser';
import { ThemeConstellation } from '@zillow/constellation';
import { ThemeProvider as SCThemeProvider } from 'styled-components';
import { bootstrap } from './bootstrap';
import { createAuthProvider } from '@zg-rentals/particles-js-auth-hooks';
import { createRoot } from 'react-dom/client';

bootstrap.register();

const history = createHistory();
const initialState = window.__INITIAL_STATE__;
const store = configureStore(initialState, history);
window.store = store;
window.browserHistory = history;
const brand = store.getState().app.brand || 'zillow';

window.browserHistory.listen((location, action) => {
  if (action === 'POP') {
    return;
  }

  window.scrollTo(0, 0);
});

window.router = {
  redirectTo(t) {
    return store.dispatch(replace(t));
  },
  transitionTo(t, escape = false) {
    if (escape) {
      let currentState = assign({}, window.history.state, {
        scrollTop: document.body.scrollTop,
      });

      window.history.replaceState(currentState, document.title, window.location.href);
      window.browserHistory.push(t);
    }

    return store.dispatch(push(t));
  },
};

const user = store.getState().user;

const AuthProvider = createAuthProvider({
  initialUser: {
    loggedIn: user.loggedIn,
    isTwoFactorEnabled: user.isTwoFactorAuthEnabled,
    isTwoFactorAuthenticated: user.isTwoFactorAuthenticated,
    hasStrongAuthentication: user.hasStrongAuthentication,
    impersonatorUserToken: user.impersonatorUserToken,
    impersonatorEmail: user.impersonatorEmail,
    isUserBlocked: user.isUserBlocked,
  },
  initialSessionExpirationDate: user.sessionExpirationDate,
});

const renderApp = () => {
  const container = document.getElementById('app-root');
  const root = createRoot(container);

  root.render(
    <ThemeProvider brand={brand}>
      <RpErrorBoundary>
        <Provider store={store}>
          <AuthProvider>
            <SCThemeProvider theme={ThemeConstellation}>
              <CookiesProvider>
                <ConnectedRouter history={history}>
                  <App />
                </ConnectedRouter>
              </CookiesProvider>
            </SCThemeProvider>
          </AuthProvider>
        </Provider>
      </RpErrorBoundary>
    </ThemeProvider>,
  );
};

renderApp();

if (module.hot) {
  module.hot.accept();
}
